import type { AgreementsActivityResult } from '../../activity-handler/agreements-activity.types';
import type { AgreementsPayload } from '../models/agreements.model';
import { fetchGetAgreementsActivity } from '../api/fetch-get-agreements-activity';

/** Injected collaborators for {@link fetchAgreementsReport} (composition root / tests). */
export interface AgreementsReportFetchDeps {
    fetchGetAgreements(
        accessToken: string,
        payload: AgreementsPayload
    ): Promise<AgreementsActivityResult>;
}

export const defaultAgreementsReportFetchDeps: AgreementsReportFetchDeps = {
    fetchGetAgreements: fetchGetAgreementsActivity,
};
